"use strict";export const getActiveElement=e=>e.getRootNode().activeElement;
//# sourceMappingURL=get-active-element.js.map
